import React from 'react';
import PropTypes from 'prop-types';
import mova from 'mova';

const t = mova.ns('containers.DishDetailsModal');

const DishQuantitySelector = ({ quantity, setQuantity, ...rest }) => {
  return (
    <div className='dish-details-modal__quantity-wrapper' {...rest}>
      <span className='dish-details-modal__quantity-title'>{t('numberOfDishes')}:</span>
      <div className='dish-details-modal__select'>
        <div
          className={`dish-details-modal__select--left ${quantity <= 1 ? 'disabled' : ''}`}
          onClick={() => quantity > 1 && setQuantity((prev) => prev - 1)}>
          -
        </div>
        <div className='dish-details-modal__select--quantity'>{quantity}</div>
        <div className='dish-details-modal__select--right' onClick={() => setQuantity((prev) => prev + 1)}>
          +
        </div>
      </div>
    </div>
  );
};

DishQuantitySelector.propTypes = {
  quantity: PropTypes.number.isRequired,
  setQuantity: PropTypes.func.isRequired,
};

export default DishQuantitySelector;
